import {ErrorMessage, Field} from 'formik'
import React, {useEffect, useState} from 'react'
import {Question} from '../../../Adaptor/TUBSIS/controllers/Tests/models/testModels'
import {Col, Container, Row} from 'react-bootstrap'
import clsx from 'clsx'
type Props = {
  id: string
  label: string
  placeholder?: string
  options?: any[]
  touched?: any
  answerSuffix?: string
  errors?: any
  props?: any
  setFieldValue: any
  setFieldTouched: any
}
const QuestionWithDayMonthYear_ForRegister: React.FC<Props> = ({
  id,
  label,
  placeholder,
  options,
  touched,
  errors,
  props,
  setFieldValue,
  setFieldTouched,
  answerSuffix,
}) => {
  const [isHesitant, setIsHesitant] = useState(false)
  const [selectedDay, setSelectedDay] = useState(null)
  const [selectedMonth, setSelectedMonth] = useState(null)
  const [selectedYear, setSelectedYear] = useState(null)
  const [totalDay, setTotalDay] = useState<number | null>(null)
  useEffect(() => {
    if (isHesitant) {
      setTotalDay(-1)
      return
    }
    var tempInt: number = 0

    if (selectedDay) {
      tempInt += parseInt(selectedDay)
    }

    if (selectedMonth) {
      tempInt += selectedMonth * 30
    }

    if (selectedYear) {
      tempInt += selectedYear * 365
    }
    setTotalDay(tempInt != 0 ? tempInt : null)
  }, [selectedDay, selectedMonth, selectedYear, isHesitant, touched, errors])
  useEffect(() => {
    console.log(totalDay)
    ////debugger
    setFieldValue(id, totalDay?.toString(), true)
  }, [totalDay])
  const drawYears = () => {
    const year = []
    for (let i = 1; i < 100; i++) {
      year.push({key: i, value: i.toString()})
    }
    return (
      <>
        <option key='ybos'></option>
        {year.map((item) => {
          return (
            <option value={item.key} key={'y' + item.key}>
              {item.value}
            </option>
          )
        })}
      </>
    )
  }
  const drawMonths = () => {
    const month = []
    for (let i = 1; i < 12; i++) {
      month.push({key: i, value: i.toString()})
    }
    return (
      <>
        <option key='mbos'></option>
        {month.map((item) => {
          return (
            <option value={item.key} key={'m' + item.key}>
              {item.value}
            </option>
          )
        })}
      </>
    )
  }
  const drawDays = () => {
    const day = []
    for (let i = 1; i < 31; i++) {
      day.push({key: i, value: i.toString()})
    }
    return (
      <>
        <option key='gbos'></option>
        {day.map((item) => {
          return (
            <option value={item.key} key={'g' + item.key}>
              {item.value}
            </option>
          )
        })}
      </>
    )
  }

  ////debugger
  return (
    <>
      <div className='fv-row mb-8'>
        <label className='form-label fw-bolder text-dark fs-6'>{label}</label>
        <div className='text-danger mt-2' key={'err' + id} id={'err' + id}>
          {touched && errors && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{errors}</span>
              </div>
            </div>
          )}
        </div>
        <Container>
          {!isHesitant && (
            <Row>
              <Col xs='4' sm='4' md='4' lg='4'>
                {/*  Yıl*/}
                <select
                  id={id + '33'}
                  autoComplete='off'
                  {...props}
                  className={clsx(
                    'form-control bg-transparent',
                    {
                      'is-invalid': touched && errors,
                    },
                    {
                      'is-valid': touched && !errors,
                    }
                  )}
                  onChange={(e: any) => {
                    ////debugger
                    setSelectedYear(e.target.value)

                    setFieldTouched(id, true)
                  }}
                >
                  {drawYears()}
                </select>

                {/* <Field
                  as='select'
                  name='33'
                  // className='form-select form-select-lg form-select-solid'
                  className={clsx(
                    'form-control bg-transparent',
                    {
                      'is-invalid': touched && errors,
                    },
                    {
                      'is-valid': touched && !errors,
                    }
                  )}
                  onChange={(e: any) => {
                    setSelectedYear(e.target.value)
                  }}
                >
                  {drawYears()}
                </Field> */}
              </Col>
              <Col className='mt-4' xs='2' sm='2' md='2' lg='2'>
                <label className='form-label'>Yıl</label>
              </Col>
              <Col xs='4' sm='4' md='4' lg='4'>
                {/*  ay*/}
                <select
                  id={id + '22'}
                  autoComplete='off'
                  {...props}
                  className={clsx(
                    'form-control bg-transparent',
                    {
                      'is-invalid': touched && errors,
                    },
                    {
                      'is-valid': touched && !errors,
                    }
                  )}
                  onChange={(e: any) => {
                    setSelectedMonth(e.target.value)

                    setFieldTouched(id, true)
                  }}
                >
                  {drawMonths()}
                </select>

                {/* <Field
                  as='select'
                  name='22'
                  className='form-select form-select-lg form-select-solid'
                  onChange={(e: any) => {
                    setSelectedMonth(e.target.value)
                  }}
                >
                  {drawMonths()}
                </Field> */}
              </Col>

              <Col className='mt-4' xs='2' sm='2' md='2' lg='2'>
                <label className='form-label'>Ay</label>
              </Col>

              <Col xs='4' sm='4' md='4' lg='4'>
                {/*  Gün*/}

                <select
                  id={id + '11'}
                  autoComplete='off'
                  {...props}
                  className={clsx(
                    'form-control bg-transparent',
                    {
                      'is-invalid': touched && errors,
                    },
                    {
                      'is-valid': touched && !errors,
                    }
                  )}
                  onChange={(e: any) => {
                    setSelectedDay(e.target.value)

                    setFieldTouched(id, true)
                  }}
                >
                  {drawDays()}
                </select>

                {/* <Field
                  as='select'
                  name='11'
                  className='form-select form-select-lg form-select-solid'
                  onChange={(e: any) => {
                    setSelectedDay(e.target.value)
                  }}
                >
                  {drawDays()}
                </Field> */}
              </Col>

              <Col className='mt-4' xs='2' sm='2' md='2' lg='2'>
                <label className='form-label '>Gün</label>
              </Col>
              {answerSuffix && (
                <Col className='mt-4' xs='6' sm='6' md='6' lg='6'>
                  <label className='form-label '>{answerSuffix}</label>
                </Col>
              )}
            </Row>
          )}
        </Container>
      </div>
    </>
  )
}
export default QuestionWithDayMonthYear_ForRegister
